import { WSTableCell } from "@wingspanhq/fe-component-library";
import {
  PayeeEngagementType,
  WorkLog,
  WorkLogConvertedResourceType
} from "@wingspanhq/wingspan-api-sdk";
import { queriesPayables } from "@query";
import { getWorkLogPayerStatusCellProps } from "../utils/getWorkLogPayerStatusCellProps";

type Props = {
  workLog: WorkLog;
  /**
   * Names the resource an unapproved work log will become, so a W-2 row is not
   * described as an invoice. Read off the row's engagement by the caller — the
   * work log itself only carries `convertedResourceType` once it has converted.
   */
  engagementType?: PayeeEngagementType | null;
};

// Renders the payer work-log status cell, fetching the work log's payable at the
// point of use. Each cell owns its own `getPayable` query, so it caches per
// payable id and refreshes on cancel/reopen via the registry's auto-invalidation
// — no shared pre-fetched map to go stale.
export const WorkLogPayerStatusCell: React.FC<Props> = props => {
  // Only a contractor work log converts into a payable — a W-2 one becomes a
  // pay statement, which must not be fetched through `getPayable`.
  const payableId =
    props.workLog.convertedResourceType ===
    WorkLogConvertedResourceType.PAY_STATEMENT
      ? undefined
      : props.workLog.convertedResourceId;

  const queryPayable = queriesPayables.getPayable.useQuery(
    { payableId: payableId as string },
    { enabled: !!payableId, retry: false }
  );

  // Deliberately no pay-statement read here. The details page names the
  // statement ("Pay statement #N"), but doing that per row would add a
  // `getPayStatement` call for every approved W-2 row in the table.
  const cellProps = getWorkLogPayerStatusCellProps({
    workLog: props.workLog,
    payable: queryPayable.data,
    engagementType: props.engagementType
  });

  return <WSTableCell {...cellProps} />;
};
